export const headTitulo = 'Ministerios';
export const headVolanta = 'Esta sección muestra la estructura organizativa de la Administración Pública Nacional Centralizada (APN) por jurisdicción. Incluye información sobre sus unidades, cargos y autoridades con una presentación visual en formato escalar o gráfico, facilitando la comprensión de la organización y su jerarquía.';
//Seccion 1
export const s01_h201 = 'ADMINISTRACION PÚBLICA NACIONAL';
export const s01_h301 = 'INFORMACION GENERAL';
export const s01_h302 = 'MINISTERIOS';
export const autoridades= 'autoridadesapn'